import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  ErrorHandler,
  type ModuleWithProviders,
  NgModule,
  Optional,
} from '@angular/core';
import { AppConfigService, ENVIRONMENT_CONFIG } from '@core/config-angular';
import type { EnvironmentConfig } from '@core/config-models';
import { JSS_DICTIONARY, type JssDictionaryResult } from '@core/jss-models';
import {
  provideTranslateService,
  TranslateDirective,
  TranslateLoader,
  TranslatePipe,
} from '@ngx-translate/core';

import { JssTranslationLoaderService } from './jss-translation-loader.service';

@NgModule({
  imports: [CommonModule, TranslatePipe, TranslateDirective],
  exports: [TranslatePipe, TranslateDirective],
})
export class CoreTranslateModule {
  static forRoot(): ModuleWithProviders<CoreTranslateModule> {
    const translateModuleProviders = provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: (
          config: EnvironmentConfig,
          http: HttpClient,
          appConfig: AppConfigService,
          dictionary: JssDictionaryResult,
          errorHandler: ErrorHandler
        ) =>
          new JssTranslationLoaderService(
            config,
            http,
            appConfig,
            dictionary,
            errorHandler
          ),
        deps: [
          ENVIRONMENT_CONFIG,
          HttpClient,
          AppConfigService,
          [new Optional(), JSS_DICTIONARY],
          ErrorHandler,
        ],
      },
    });

    return {
      ngModule: CoreTranslateModule,
      providers: [translateModuleProviders],
    };
  }
}
